import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { actions } from 'shared/actions/app';
import { workingHoursHoc, WorkingHours } from 'queries/ExchangeWorkingHours/hoc';
import moment from 'moment';

import './index.scss';

interface Props {
  symbol: string;
  align?: 'center';
}

type Enhanced = Props &
  InjectedTranslateProps &
  WorkingHours &
  ReturnType<typeof mapDispatchToProps>;

const b = b_.with('stock-landing-authentication');

const mapDispatchToProps = (dispatch: Dispatch, { symbol }: Props) => ({
  signup: () =>
    dispatch(
      actions.showAuthModal(
        'signup',
        `investments/stocks/${symbol}`,
        'desktopInvestmentRegistration'
      )
    ),
  signin: () =>
    dispatch(
      actions.showAuthModal(
        'signin',
        `investments/stocks/${symbol}`,
        'desktopInvestmentRegistration'
      )
    ),
});

const enhance = compose<Enhanced, Props>(
  translate,
  workingHoursHoc,
  connect(undefined, mapDispatchToProps)
);

const StockLandingAuthentication: React.FC<Enhanced> = ({ t, signin, signup, from, to, align }) => {
  const hours = {
    from: moment(from).format('HH:mm'),
    to: moment(to).format('HH:mm'),
  };

  return (
    <div className={b({ align })}>
      <div className={b('row')}>
        <button className={b('signup')} onClick={signup}>
          {t('Sign Up')}
        </button>
        <button className={b('signin')} onClick={signin}>
          {t('Sign In')}
        </button>
      </div>
      <div className={b('working-hours')}>
        {t('The Exchange works from {{ from }} to {{ to }}', hours)}
      </div>
    </div>
  );
};

export default enhance(StockLandingAuthentication);
